<template>
    <broadcast-card eyebrow="Στατιστικά αγώνα" title="Σύγκριση ομάδων">
        <broadcast-compare :sides="sides" :rows="rows" />
    </broadcast-card>
</template>

<script>
    import BroadcastCard from '@/components/BroadcastCard'
    import BroadcastCompare from '@/components/BroadcastCompare'
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    const ASSETS_URL = 'https://storage.googleapis.com'

    const STATS = [
        { key: 'points', label: 'Πόντοι' },
        { key: 'two', label: 'Δίποντα', made: 'twoPointsMade', attempts: 'twoPointAttempts' },
        { key: 'three', label: 'Τρίποντα', made: 'threePointsMade', attempts: 'threePointAttempts' },
        { key: 'free', label: 'Βολές', made: 'freeThrowsMade', attempts: 'freeThrowAttempts' },
        { key: 'offensiveRebounds', label: 'Επιθετικά ριμπάουντ' },
        { key: 'defensiveRebounds', label: 'Αμυντικά ριμπάουντ' },
        { key: 'assists', label: 'Ασίστ' },
        { key: 'steals', label: 'Κλεψίματα' },
        { key: 'blockedShots', label: 'Κοψίματα' },
        { key: 'turnovers', label: 'Λάθη', lowerIsBetter: true },
        // every foul: personal, technical and unsportsmanlike
        { key: 'fouls', label: 'Φάουλ', lowerIsBetter: true }
    ]

    // Half-time / full-time: the two teams' totals of this match side by side
    export default {
        name: 'HalfTime',
        components: { BroadcastCard, BroadcastCompare },
        props: {
            match: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            colors() {
                return getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.dark)
            },
            sides() {
                return ['team1', 'team2'].map((key) => {
                    const team = this.match[key] || {}
                    return { name: team.name, logo: team.logo ? `${ASSETS_URL}/${team.logo}` : null, color: this.colors[key] }
                })
            },
            totals() {
                return ['team1', 'team2'].map((key) => {
                    const totals = {}
                    const players = (this.match[key] && this.match[key].players) || []
                    players.forEach((player) => {
                        const stats = (player.stats && player.stats[0]) || {}
                        Object.keys(stats).forEach((field) => {
                            if (typeof stats[field] === 'number') totals[field] = (totals[field] || 0) + stats[field]
                        })
                    })
                    totals.fouls = (totals.personalFouls || 0) + (totals.technicalFouls || 0) + (totals.unsportsmanlikeFouls || 0) +
                        (totals.disruptiveFouls || 0) + (totals.flagrantFouls || 0)
                    return totals
                })
            },
            rows() {
                const [t1, t2] = this.totals
                return STATS.map((stat) => {
                    if (!stat.made) {
                        return { key: stat.key, label: stat.label, value1: t1[stat.key] || 0, value2: t2[stat.key] || 0, lowerIsBetter: stat.lowerIsBetter }
                    }
                    const side = (totals) => {
                        const made = totals[stat.made] || 0
                        const attempts = totals[stat.attempts] || 0
                        const pct = attempts ? Math.round(made / attempts * 100) : 0
                        return { pct, display: `${pct}%`, detail: `${made}/${attempts}` }
                    }
                    const a = side(t1)
                    const b = side(t2)
                    return { key: stat.key, label: stat.label, value1: a.pct, value2: b.pct, display1: a.display, display2: b.display, detail1: a.detail, detail2: b.detail }
                })
            }
        }
    }
</script>
